// extracted by mini-css-extract-plugin
module.exports =  {"container":"_9330de7794--container--XUZ0I","title":"_9330de7794--title--PcmPs","title-text-element":"_9330de7794--title-text-element--U_fJr"};